import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getSDUIConfig = (state) => resolveProp('market.sduiConfig', state);

export default createSelector(getSDUIConfig, (sduiConfig) => sduiConfig);
